<template>
  <!-- 社教活动管理 -->
  <div class="page-activity-manage">
    <!-- 列表头部 -->
    <div class="com-list-header">

      <el-form @keyup.enter.native="getTableList" class="com-search-box" ref="form" :model="form" label-width="70px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="关键字 :" prop="text">
              <el-input placeholder="请输入" v-model="form.text"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item class="el-form-state" label="状态 :" prop="status">
              <el-select v-model="form.status" placeholder="请选择">
                <el-option v-for="item in statusList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="7">
            <el-form-item class="el-form-time"  label="报名截止时间 :" prop="time">
              <el-date-picker v-model="form.time" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="请选择"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 30px;top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;新建社会活动
          </el-button>

          <!-- <el-button round @click="exportList">
            <svg-icon icon-class="add" />&nbsp;导出
          </el-button> -->
          <!-- <cmpMyExport
            class="ml-20"
            @clearSelectsCall="clearSelectsCall"
            :chooseIds="chooseRowIds"
            :chooseApi="`/scheme/exportScheme?arr=`"
            :searchApi="`/scheme/exportSchemeAll?schemeName=`+form.schemeName+`&schemeNumber=`+form.schemeNumber+`&planYear=`+form.planYear+`&dataState=`+form.dataState"
          ></cmpMyExport>-->
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData" @selection-change="handleSelectionChange">
          <!-- <el-table-column type="selection" :reserve-selection="true" width="42"></el-table-column> -->
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="serviceName" label="活动名称" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column label="招募状态" min-width="8%">
            <template slot-scope="scope">{{ scope.row.status | filterVolunteerRecruit(that) }}</template>

          </el-table-column>
          <el-table-column label="活动时间" min-width="15%">
            <template slot-scope="scope">{{ scope.row.serviceTimeBegin}} - {{ scope.row.serviceTimeEnd}}</template>
          </el-table-column>
          <el-table-column prop="quota" label="活动名额" min-width="7%"></el-table-column>
          <el-table-column prop="quotaAlready" label="已报名" min-width="7%">
            <template slot-scope="scope">{{ scope.row.quotaAlready || 0 }}</template>

          </el-table-column>
          <el-table-column prop="deadlineTime" label="报名截止" min-width="10%" show-overflow-tooltip></el-table-column>

          <!-- <el-table-column prop="schemeNumber" label="状态" min-width="6%">
            <template slot-scope="scope">
              <span>已注册</span>
            </template>
          </el-table-column>-->

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="18%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" v-if="scope.row.status=='0'" @click="handlePublish(scope.row)">发布</a>
              <a class="m-btn mr-10" @click="handleAdd('detail', scope.row.id)">查看</a>
              <a class="m-btn mr-10"  v-if="scope.row.status=='0'" @click="handleAdd('edit', scope.row.id)">编辑</a>
              <a class="m-btn mr-10 m-danger"  v-if="scope.row.status=='0'" @click="handleDelete(scope.row.id)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <dialogAddActivity ref="dialogAddActivity" @refresh="restList"></dialogAddActivity>
    <!-- <dialogActivityInfo ref="dialogActivityInfo" @refresh="restList"></dialogActivityInfo>
    <dialogQrcode ref="dialogQrcode" @refresh="restList"></dialogQrcode> -->
  </div>
</template>

<script>
import cmpMyExport from '@cmp/my-export'
import dialogAddActivity from './dialog-add-activity'
export default {
  components: {
    cmpMyExport,
    dialogAddActivity,
    // dialogActivityInfo,
    // dialogQrcode
  },
  data() {
    return {
      that: this,
      form: {
        text: '',
        type: '', //	活动类型
        status: '', //	活动状态
        serviceType: '1' //活动类型 1-社会活动报名 2-接待讲解 3-社会教育活动 4-临展报名
      },
      serviceList: [{ id: '1', name: '赴农村' }, { id: '2', name: '进校园' }, { id: '3', name: '进企业' }, { id: '4', name: '进军营' }, { id: '5', name: '进计关' }, { id: '6', name: '进社区' }, { id: '7', name: '其他' }],
      typeList: [],
      statusList: [],
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      activeIndex: null,
      tableData: [],
    }
  },
  filters: {
    filterVolunteerRecruit(status, context) {
      let arr = context.statusList.filter(item => {
        return item.dictCode == status
      })

      if (arr && arr.length > 0) {
        return arr[0].dictName
      }

      return null
    },
  },
  methods: {
    // 初始化表格
    initList(type) {
      this.listLoading = true
      this.$api.volunteer.getVolunteerRecruitList({
        ...this.listQuery,
        ...this.form
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result) {
            this.tableData = res.result.records || []
            this.total = res.result.total || 0
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    // 发布
    handlePublish(item) {
      this.$http
        .get('/v2/bsVolunteerV2Recruit/publish', {
          id: item.id,
        })
        .then(res => {
          if (res.success) {
            this.$message.success('发布成功')
            this.initList()
          } else {
            this.$message.error(res.message)
          }
        })
    },

    //活动类型改变
    handleTypeChange(item) {
      console.log(item)
      this.activeIndex = item
    },

    // 获取下拉状态多选择值
    getDropdownValue() {
      this.$http.post('/collectDict/getSelectDataByArr', {
        arr: ['volunteer_recruit_status']
      }).then(res => {
        if (res.success) {
          var state = res.result, total = 0
          let firstArr = [{ dictCode: null, dictName: '全部', count: 0 }]
          // this.typeList = firstArr.concat(state['activity_type'])
          this.statusList = firstArr.concat(state['volunteer_recruit_status'])
        } else {
          // this.$message.error(res.message)
        }
      })
    },

    handleClickNav(item) {
      this.activeIndex = item.id
      this.form.type = item.id
      this.getTableList()
    },

    // 重置查询
    restList() {
      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()

    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 删除
    handleDelete(id) {
      this.$common.confirm(
        {
          title: '您正在删除活动，是否确认删除？',
          className: 'cus-confirm-375'
        },
        () => {
          this.$api.volunteer.deleteVolunteerRecruit({
            id: id
          }).then(res => {
            if (res.success) {
              this.$message.success('活动删除成功')
              this.initList('dele')
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 新增
    handleAdd(type, id) {
      if (type == 'detail') {
        this.$router.push({
          path: '/volunteer/sign-detail',
          query: { id: id }
        })
        return
      }
      this.$refs.dialogAddActivity.init(type, id)
    },

    // 导出
    exportList() { },
    // 资料管理
    handleShowInfo(id) {
      this.$refs.dialogActivityInfo.init(id)
    },

    handleShare(id) {
      this.$refs.dialogQrcode.init(id, '2')
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach(item => {
        arr.push(item.schemeId)
      })
      this.chooseRowIds = arr.join(',')
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },
    // 清空选中状态
    clearSelectsCall() {
      this.$refs.multipleTable.clearSelection()
    }
  },
  created() {
    this.initList()
    this.getDropdownValue()
  }
}
</script>

<style lang="scss" scoped>
.page-activity-manage {
  .nav-list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    .nav-item {
      margin-bottom: 10px;
      padding: 5px 10px;
      color: $color6;
      font-size: 14px;
      border: solid 1px $border;
      border-radius: 4px;
      margin-right: 20px;
      cursor: pointer;
      &.active {
        background-color: $primary;
        color: #fff;
        border-color: $primary;
      }
    }
  }
}
.el-form-state{
  /deep/ .el-form-item__label{
    width: 60px !important;
  }
}

.el-form-time{
  /deep/ .el-form-item__label{
    width: 120px !important;
  }
  /deep/ .el-form-item__content{
    margin-left: 120px !important;
  }
}
</style>